import React from 'react'
import './Our_Services.css'
import Smart_Finance_Solutions_card from './Smart_Finance_Solutions_card/Smart_Finance_Solutions_card'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Grid, Pagination } from 'swiper/modules'
import "swiper/css";
import "swiper/css/grid";
import "swiper/css/pagination";

const Our_Services = () => {

    const slides = Array.from({ length: 15 }, (_, index) => index + 1);

    const data = [
        {
            img: "/assets/Image/Home/Our_Services/img.png",
            text: "HOME LOAN",
          },
          {
            img: "/assets/Image/Home/Our_Services/img2.png",
            text: "PERSONAL LOAN",
          },
          {
            img: "/assets/Image/Home/Our_Services/img3.png",
            text: "CAR LOAN",
          },
          {
            img: "/assets/Image/Home/Our_Services/img4.png",
            text: "CREDIT CARD LOAN",
          },
          {
            img: "/assets/Image/Home/Our_Services/img5.png",
            text: "BUSINESS LOAN",
          },
          {
            img: "/assets/Image/Home/Our_Services/img6.png",
            text: "GOLD LOAN",
          },
          {
            img: "/assets/Image/Home/Our_Services/img7.png",
            text: "MICRO LOAN",
          },
          {
            img: "/assets/Image/Home/Our_Services/img8.png",
            text: "PROPERTY LOAN",
          },
         
    ]

    return (
        <section className='Our_Services'>

            <div className='container'>

                <div className='heading_main_div'>
                    <div className='first_div'>
                        <p className='section_heading'>Our Services</p>
                    </div>
                    <div className='second_div'>
                        <p className='text'>LOANS & INSURANCE</p>
                    </div>
                </div>


                <div className="Smart_Finance_Solutions_holder">
                    <div className="row">
                        <div className="col-md-2 col-3">
                            <div className="Loan_heading_holder">LOANS</div>
                        </div>

                        <div className="col-md-10 col-9">
                            <Swiper
                                slidesPerView={4}
                                grid={{
                                    rows: 2,
                                }}
                                spaceBetween={50}
                                pagination={{
                                    clickable: true,
                                }}
                                modules={[Grid, Pagination]}
                                loop={true}
                                className="mySwiper Smart_Finance_Solutions_slider"
                                breakpoints={{
                                    0: {
                                        slidesPerView: 2.2, // 4 slides on larger screens
                                        spaceBetween: 15,
                                    },

                                    485: {
                                        slidesPerView: 2.5, // 4 slides on larger screens
                                        spaceBetween: 15,
                                    },

                                    575: {
                                        slidesPerView: 2.5, // 4 slides on larger screens
                                        spaceBetween: 15,
                                    },

                                    768: {
                                        slidesPerView: 3.5, // 4 slides on larger screens
                                        spaceBetween: 15,
                                    },

                                    992: {
                                        slidesPerView: 3.5, // 4 slides on larger screens
                                        spaceBetween: 15,
                                    },

                                    1024: {
                                        slidesPerView: 3.5, // 4 slides on larger screens
                                        spaceBetween: 15,
                                    },

                                    1200: {
                                        slidesPerView: 3.5, // 4 slides on larger screens
                                        spaceBetween: 15,
                                    },

                                    1300: {
                                        slidesPerView: 4, // 4 slides on larger screens
                                        spaceBetween: 15,
                                    },
                                }}
                            >
                                {data?.map((item) => (
                                    <SwiperSlide>
                                        <Smart_Finance_Solutions_card img={item?.img} loan={item?.text} />
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                    </div>
                </div>

            </div>

        </section>
    )
}

export default Our_Services
